<app-modal class="new-project" [(visible)]="isNewProjectVisible" header="CREATE NEW PROJECT"
  (visibleChange)="visibleChange($event)" (onCancel)="cancel()" >
  <form [formGroup]="formGroup">
    <div class="p-grid p-fluid basic-filter">
      <div class="p-grid p-col-12">
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup"  [model]="projectName"></form-factory>
        </div>
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="projectOwners"></form-factory>
        </div>
      </div>
      <div class="p-grid p-col-12">
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="projectTypes" (onChange)="projectTypeSelectionChange($event)">
          </form-factory>
        </div>
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="projectRetrievalType"></form-factory>
        </div>
      </div>
      <div class="p-grid p-col-12" *ngIf="!isChartLakeProject && isShowProjectReviewPeriod">
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="projectReviewPeriodFromDate"
                        (onBlur)="onDateChange(projectReviewPeriodFromDate,projectReviewPeriodThruDate)"></form-factory>
        </div>
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="projectReviewPeriodThruDate"
                        (onBlur)="onDateChange(projectReviewPeriodFromDate,projectReviewPeriodThruDate)"></form-factory>
        </div>
      </div>
      <div *ngIf="!isChartLakeProject && isShowProjectPeriod && !isMemberManagementProject" class="p-grid p-col-12 p-md-12 p-lg-12">
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="projectStartDate" (onBlur)="projectEndDateChange()"></form-factory>
        </div>
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="projectEndDate" (onBlur)="projectEndDateChange()"></form-factory>
        </div>
      </div>
      <div class="p-col-12 p-md-12 p-lg-12" *ngIf="shouldShowMARADVProject">
        <div class="p-col-12 p-md-12 p-lg-6">
          <div class="radv_header" for="enableMARADVProject">Is this a MA RADV Project?</div>
          <form-factory [formGroup]="riskFormGroup" [model]="enableMARADVProject"
            (onChange)="onEnableMARADVProject()"></form-factory>
        </div>
      </div>
      <div class="p-col-12 p-md-12 p-lg-12" *ngIf="shouldShowRiskProgramType">
        <div class="p-col-12 p-md-12 p-lg-6">
          <div class="radv_header" for="enableMARADVProject">Risk Program Type</div>
          <form-factory [formGroup]="riskFormGroup" [model]="riskProgramType"
            (onChange)="onRiskProgramTypeChange()"></form-factory>
        </div>
      </div>
      <div class="p-grid p-col-12" *ngIf="shouldShowRiskProjectFields">
        <div class="p-col-12 p-md-12 p-lg-6" *ngIf="isRiskProject">
          <form-factory [customTemplate]="customItem" [formGroup]="riskFormGroup" [model]="codingReviewMode"></form-factory>
          <ng-template let-item #customItem>
            <div class="dropdown-item">
              {{item?.text}} <app-tool-tip [text]="item?.extra?.tooltip" tooltipPosition="right" ></app-tool-tip>
            </div>
          </ng-template>
        </div>
         <div class="p-col-12 p-md-12 p-lg-6" *ngIf="useRiskSettings">
          <form-factory [formGroup]="riskFormGroup" [model]="lineOfBusiness"
                        (onChange)="lineOfBusinessSelectionChange($event)"></form-factory>
        </div>
        <div class="p-col-12 p-md-12 p-lg-6" *ngIf="isIVAProject">
          <form-factory [formGroup]="riskFormGroup" [model]="hcc" (onChange)="onhccSelection($event)"></form-factory>
        </div>
      </div>
      <div class="p-col-12" *ngIf="isRiskProject && shouldShowRiskProjectFields">
       <div class="error" *ngIf="showHccValidationError">
                {{ hccRiskModelSwitchList.errorMessages?.atLeastOneRequired }}
         </div>
         <div class="info-box" *ngIf="coachingBoxNoteForLOB">
         <i><strong>Note:</strong> {{ coachingBoxNoteForLOB }}</i>
         </div>
        <div class="custom-switch-wrapper p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="riskFormGroup" [model]="hccRiskModelSwitchList"></form-factory>
        </div>
      </div>
      <div *ngIf="!isChartLakeProject && isShowMeasurementAndReportingYear" class="p-grid p-col-12 p-md-12 p-lg-12">
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="measurementInput"></form-factory>
        </div>
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="reportingYearInput"></form-factory>
        </div>
      </div>
      <div class="p-grid p-col-12" *ngIf="shouldShowRiskProjectFields">
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="productTypes" (onChange)="productTypeSelectionChange($event)"></form-factory>
        </div>
        <div class="p-col-12 p-md-12 p-lg-6">
          <form-factory [formGroup]="formGroup" [model]="clientOrgs"></form-factory>
        </div>
      </div>
    </div>
  </form>
  <footer>
    <app-button class="header-button" text="SAVE AND CONFIGURE" (onClick)="createProject()" [disabled]="!isFormValid">
    </app-button>
  </footer>
</app-modal>
